import React from 'react'
import withApollo from '@chegg-wt/core/api/graphApi'
import { useConvertAndImport } from '@chegg-wt/core/hooks/useConvertAndImport'
import { getSummaryTitle } from '@chegg-wt/core/utils/importSummary'
import { ErrorComponent } from '../ErrorContainer'
import { LoadingDots } from '../LoadingDots'
import * as Styled from './styled'
import {
  IMPORT_CITATION_BUTTON_ID,
  IMPORT_SUMMARY_CONTAINER,
  RADIO_BUTTON_WITHABSTRACTS_ID,
  RADIO_BUTTON_WITHOUTABSTRACTS_ID,
} from './testIds'

export interface ImportCitationContainerProps {
  rawCitationsData: string
  isPremiumFlow: boolean
}

const LoadingDotsWithMessage = ({ convertData }) => {
  return (
    <LoadingDots
      message={!convertData ? 'Loading Citations Summary' : 'Importing Citations'}
    />
  )
}

export const ImportCitationContainer: React.FC<ImportCitationContainerProps> = ({
  rawCitationsData,
  isPremiumFlow,
}) => {
  const {
    convertError,
    setWithAnnotation,
    convertData,
    mutationError,
    citationCreator,
    isLoading,
  } = useConvertAndImport(rawCitationsData, isPremiumFlow)

  const citations = convertData?.convertCitationFormat
  let containerChildren = null

  if (mutationError) {
    containerChildren = <ErrorComponent error="Import of Citations Failed!" />
  } else if (isLoading && !convertError)
    containerChildren = <LoadingDotsWithMessage convertData={convertData} />
  else if (convertError || convertData?.convertCitationFormat?.length === 0) {
    containerChildren = <ErrorComponent error="No data to Import!" />
  } else
    containerChildren = (
      <Styled.DataContainer data-test={IMPORT_SUMMARY_CONTAINER}>
        <Styled.Header>Import the following {citations.length} citations:</Styled.Header>
        <Styled.OrderedList>
          {citations.map((citation, ind) => (
            // eslint-disable-next-line react/no-array-index-key
            <Styled.ListItem key={ind}>{getSummaryTitle(citation)}</Styled.ListItem>
          ))}
        </Styled.OrderedList>
        <Styled.Footer>
          <Styled.RadioInput
            type="radio"
            name="data"
            defaultChecked
            onChange={() => setWithAnnotation(false)}
            aria-labelledby="withoutAbstracts"
            data-test={RADIO_BUTTON_WITHOUTABSTRACTS_ID}
          />
          <span id="withoutAbstracts">Without abstracts</span>
          <Styled.RadioInput
            type="radio"
            name="data"
            onChange={() => setWithAnnotation(true)}
            aria-labelledby="withAbstracts"
            data-test={RADIO_BUTTON_WITHABSTRACTS_ID}
          />
          <span id="withAbstracts"> With abstracts</span>
          <p>
            <Styled.SubmitButton
              type="submit"
              onClick={citationCreator}
              data-test={IMPORT_CITATION_BUTTON_ID}
            >
              Import
            </Styled.SubmitButton>
          </p>
        </Styled.Footer>
      </Styled.DataContainer>
    )

  return <Styled.Container>{containerChildren}</Styled.Container>
}

export default withApollo({ ssr: false })(ImportCitationContainer)
